export enum JobAction {
  VIEW = 'view-job',
  VIEW_JOB_INFO = 'view-job-info',
  EDIT = 'edit',
  SHARE = 'share',
  REFRESH = 'refresh',
  COPY = 'copy',
  EXPIRE = 'expire',
  NOTIFICATION_PREFERENCE = 'notifications',
  TEAM_MEMBER_ACCESS = 'team-access',
  MULTI_LOCATION = 'multi-location',
}
